import LazyBackgroundImage from './LazyBackgroundImage';
export default LazyBackgroundImage;